// Web'in kendi rozet yüzeyi: tarayıcı sekmesi (mimari 9.26.7.2.3).
//
// Dock rozeti web'de zaten çalışıyor (aynı bileşen), ama sekme arka plandayken
// kullanıcı onu görmüyor — mobildeki uygulama simgesi rozetinin (9.26.7.3) web
// karşılığı sekme başlığı ve favicon'dur.
//
// Sayı olarak **mesaj** toplamı kullanılıyor, mesaj + bekleyen istek toplamı
// değil: bu yüzey simge rozetinin aynası ve onun sözleşmesi (9.26.7.3.3)
// okunmamış mesaj toplamı. Bekleyen buluşma isteklerinin yüzeyi dock ve Takvim.
import { formatBadgeCount } from './badge';

export const BASE_TITLE = 'nosubject';

type LinkLike = { href: string; rel?: string; type?: string };
type DocumentLike = {
  title: string;
  querySelector: (selector: string) => LinkLike | null;
  createElement: (tag: string) => any;
  head: { appendChild: (el: any) => void };
};

export function webTitle(count: number, base: string = BASE_TITLE): string {
  return count > 0 ? `(${formatBadgeCount(count)}) ${base}` : base;
}

// Favicon'un dokunulmamış hâli: rozet sıfıra düşünce geri konabilsin diye ilk
// görüldüğü gibi saklanıyor (sonraki çizimler kendi çıktısını kaynak almasın).
let pristineIcon: string | null = null;

function iconLink(doc: DocumentLike): LinkLike | null {
  const existing = doc.querySelector('link[rel~="icon"]');
  if (existing) return existing;
  const created = doc.createElement('link');
  if (!created) return null;
  created.rel = 'icon';
  doc.head.appendChild(created);
  return created;
}

/**
 * Sekme başlığını ve favicon'u sayaca göre günceller. Yalnız web'de anlamlı;
 * `document` yoksa (native, test) sessizce çıkar — çağıran taraf platform
 * kontrolü yapmak zorunda kalmasın.
 */
export function applyWebBadge(count: number, doc?: DocumentLike): void {
  // `document`/`Image` DOM tipleri projenin tsconfig'inde yok (native hedef);
  // web'de var olduklarını globalThis üzerinden okuyoruz.
  const g = globalThis as any;
  const d = doc ?? (g.document ? (g.document as DocumentLike) : null);
  if (!d) return;

  d.title = webTitle(count);

  const link = iconLink(d);
  if (!link) return;
  if (pristineIcon === null) pristineIcon = link.href || '';
  if (count <= 0) {
    if (pristineIcon) link.href = pristineIcon;
    return;
  }
  drawDot(d, link, pristineIcon);
}

// Favicon'un üstüne kırmızı nokta basar. Sayı 16×16'da okunmuyor; nokta
// "bekleyen bir şey var" demek için yeterli, kesin sayı zaten başlıkta.
function drawDot(doc: DocumentLike, link: LinkLike, source: string | null): void {
  try {
    const canvas = doc.createElement('canvas');
    const ctx = canvas?.getContext?.('2d');
    if (!ctx) return;
    canvas.width = 64;
    canvas.height = 64;

    const paint = () => {
      ctx.beginPath();
      ctx.arc(46, 18, 18, 0, Math.PI * 2);
      ctx.fillStyle = '#e53935';
      ctx.fill();
      link.href = canvas.toDataURL('image/png');
    };

    if (!source || !(globalThis as any).Image) { paint(); return; }
    const img = new (globalThis as any).Image();
    img.onload = () => { ctx.drawImage(img, 0, 0, 64, 64); paint(); };
    img.onerror = () => paint();
    img.src = source;
  } catch {
    // Favicon çizimi kozmetik; başarısız olursa başlıktaki sayı zaten duruyor.
  }
}
